export const contractsBCPath = 'contracts-bc';

export const billingBCPath = 'billing-bc';
